import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { RoutesConstant } from './@shared/constants/Routes.constant';

@NgModule({
  imports: [RouterModule.forRoot(RoutesConstant, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
